import React, { useState } from "react";
import { Link } from "react-router-dom";

import Pillar1 from "../assets/images/slider/home/slider-img-1.png";
import Pillar2 from "../assets/images/slider/home/slider-img-2.png";
import Pillar3 from "../assets/images/slider/home/slider-img-3.png";
import Pillar4 from "../assets/images/slider/home/slider-img-4.png";
import Pillar5 from "../assets/images/slider/home/slider-img-5.png";

const HomeSlider = () => {
  const [current, setCurrent] = useState(0);

  const slides = [
    {
      image: Pillar1,
      headline: "We are enterprise travel technology partners.",
      body: "For 24 years, we've built complex travel systems for 500+ companies across 100+ countries. We don't just build travel software — we extend your existing infrastructure, enable AI at your pace, deploy specialist engineers on-site when it matters, and build bespoke platforms when you need custom solutions. One partner. Every stage of your journey.",
      cta: "Explore Our Services",
      link: "/solutions/travel-agency-software",
      icon: null
    },
    {
      image: Pillar2,
      headline: "Manage Your Existing Infrastructure",
      body: "We maintain and operate your existing travel stack — no forced migration, no unnecessary disruption. Your infrastructure stays stable while we layer in modern capabilities.",
      cta: "Learn more",
      link: "/solutions/travel-agency-software",
      icon: "⚙️"
    },
    {
      image: Pillar3,
      headline: "Enable AI at Your Pace",
      body: "Analytics and intelligence layered across your existing travel vertical — search, pricing, automation, and back-office workflows. Without forcing a platform replacement.",
      cta: "Explore AI",
      link: "/solutions/travel-agency-software",
      icon: "✦"
    },
    {
      image: Pillar4,
      headline: "Build Custom Platforms",
      body: "Custom-built travel platforms designed around your exact commercial model and delivered as your IP. When off-the-shelf won't fit, we build it right.",
      cta: "Start building",
      link: "/solutions/travel-agency-software",
      icon: "◇"
    },
    {
      image: Pillar5,
      headline: "Deploy Specialist Engineers",
      body: "Dedicated engineering team embedded with your organization — GDS, NDC, supplier connectivity expertise. Your extension, not a vendor.",
      cta: "Meet the team",
      link: "/solutions/travel-agency-software",
      icon: "⊡"
    }
  ];

  const handleSlide = (action) => {
    if (action === "next") {
      setCurrent((current + 1) % slides.length);
    }
    if (action === "prev") {
      setCurrent((current - 1 + slides.length) % slides.length);
    }
  };

  const slide = slides[current];

  return (
    <div className="home-slider" style={{ position: "relative", width: "100%", overflow: "hidden" }}>
      <div
        className="home-slide"
        style={{
          backgroundImage: `url(${slide.image})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          height: "600px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          position: "relative",
          width: "100%"
        }}
      >
        {/* Dark overlay for text readability */}
        <div style={{
          position: "absolute", inset: 0,
          background: "linear-gradient(135deg, rgba(5,15,50,0.72) 0%, rgba(10,30,80,0.60) 100%)",
          zIndex: 1
        }} />

        {/* Slider content */}
        <div
          className="home-slider-content"
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            zIndex: 3,
            width: "90%",
            maxWidth: "900px",
            padding: "40px",
            textAlign: "center",
            color: "white"
          }}
        >
          {/* Icon (for pillars 2-5) */}
          {slide.icon && (
            <div
              style={{
                fontSize: "48px",
                marginBottom: "20px",
                opacity: 0.9
              }}
            >
              {slide.icon}
            </div>
          )}

          {/* Headline — h1: this is the page's primary heading */}
          <h1
            style={{
              fontSize: slide.icon ? "36px" : "42px",
              fontWeight: 700,
              marginTop: 0,
              marginBottom: "20px",
              lineHeight: 1.2,
              color: "white"
            }}
          >
            {slide.headline}
          </h1>

          {/* Body text */}
          <p
            style={{
              fontSize: "18px",
              lineHeight: 1.8,
              marginBottom: "30px",
              opacity: 0.95,
              maxWidth: "600px",
              marginLeft: "auto",
              marginRight: "auto",
              color: "white"
            }}
          >
            {slide.body}
          </p>

          {/* CTA Button */}
          <Link
            to={slide.link}
            className="btn btn-primary"
            style={{
              display: "inline-block",
              backgroundColor: "white",
              color: "#1f2937",
              padding: "12px 28px",
              borderRadius: "6px",
              fontWeight: 600,
              textDecoration: "none",
              border: "none",
              cursor: "pointer",
              fontSize: "16px",
              transition: "all 0.3s ease"
            }}
          >
            {slide.cta} →
          </Link>
        </div>
      </div>

      {/* Navigation arrows */}
      <button
        onClick={() => handleSlide("prev")}
        style={{
          position: "absolute",
          left: "20px",
          top: "50%",
          transform: "translateY(-50%)",
          backgroundColor: "rgba(255, 255, 255, 0.2)",
          border: "none",
          color: "white",
          fontSize: "24px",
          width: "50px",
          height: "50px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          cursor: "pointer",
          transition: "all 0.3s ease",
          zIndex: 3,
          borderRadius: "4px"
        }}
        onMouseEnter={(e) => (e.target.style.backgroundColor = "rgba(255, 255, 255, 0.4)")}
        onMouseLeave={(e) => (e.target.style.backgroundColor = "rgba(255, 255, 255, 0.2)")}
      >
        ❮
      </button>

      <button
        onClick={() => handleSlide("next")}
        style={{
          position: "absolute",
          right: "20px",
          top: "50%",
          transform: "translateY(-50%)",
          backgroundColor: "rgba(255, 255, 255, 0.2)",
          border: "none",
          color: "white",
          fontSize: "24px",
          width: "50px",
          height: "50px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          cursor: "pointer",
          transition: "all 0.3s ease",
          zIndex: 3,
          borderRadius: "4px"
        }}
        onMouseEnter={(e) => (e.target.style.backgroundColor = "rgba(255, 255, 255, 0.4)")}
        onMouseLeave={(e) => (e.target.style.backgroundColor = "rgba(255, 255, 255, 0.2)")}
      >
        ❯
      </button>

      {/* Dot navigation */}
      <div
        style={{
          position: "absolute",
          bottom: "20px",
          left: "50%",
          transform: "translateX(-50%)",
          display: "flex",
          gap: "12px",
          zIndex: 3
        }}
      >
        {slides.map((_, index) => (
          <button
            key={index}
            onClick={() => setCurrent(index)}
            style={{
              width: index === current ? "30px" : "12px",
              height: "12px",
              borderRadius: index === current ? "6px" : "50%",
              backgroundColor: index === current ? "white" : "rgba(255, 255, 255, 0.5)",
              border: "none",
              cursor: "pointer",
              transition: "all 0.3s ease"
            }}
          ></button>
        ))}
      </div>
    </div>
  );
};

export default HomeSlider;
